import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {PlansDataService} from '../../components/plans/plans-data.service';
import {IPayPalConfig} from 'ngx-paypal';
import {Router} from '@angular/router';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {BusyService} from '../../services/busy.service';
import {GoogleTagService} from '../../../../../shared/src/lib/services/google-tag.service';
import {FlowTypeService} from '../../../../../shared/src/lib/services/flow-type.service';
import {DataService} from '../../../../../firebase/src/lib/services/data.service';
import {Subscription} from 'rxjs';
import {AuthComponent} from '../../components/auth/auth.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

declare var paypal: any;

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit, OnDestroy {
    items: any[] = [];
    environment = environment;
    successRoute = 'cs';
    requestType: 'capture' | 'authorize' = null;
    returnUrl = 'cs';
    submitButtonText = 'Пройти тест';
    paymentError = false;

    loading = false;
    activePlan = null;
    payPalLoading = false;
    $latestResultId: Subscription;
    $getPlan: Subscription;
    $userState: Subscription;
    public payPalConfig?: IPayPalConfig;

    constructor(
        public data: DataService,
        private planSets: PlansDataService,
        private router: Router,
        private auth: AuthService,
        private tostr: ToastrService,
        private busy: BusyService,
        private gtService: GoogleTagService,
        private flowTypeService: FlowTypeService,
        private modalService: NgbModal,
    ) {

    }

    ngOnInit(): void {
        if (this.auth.isLoggedIn) {
            this.configPayment();
        } else {

        }

    }

    login() {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });

        modalRef.result.then((res: any) => {
            if (res) {
                this.configPayment();
            }
        });
    }

    configPayment() {
        this.$latestResultId = this.data.$latestResultId.subscribe((res) => {
            this.successRoute = this.flowTypeService.state === 'ai' ? 'cs' : `/s/${res}/r`;
        });
        this.$getPlan = this.getPlan()
            .subscribe((res: any) => {
                this.items = res.filter((el: any) => el.type === 'subscription')
                    .map((el: any) => {
                        if (el.frequency === 'annual') {
                            el.title = 'Experience the first 7 days of Anima’s AI companion for free when you subscribe today. Get personalized support, neuroscience-based insights, and daily guidance — all in one place. After the trial, it’s just $4.99/month, billed annually at $59.88. Cancel anytime.';
                        } else if (el.frequency === 'monthly') {
                            el.title = 'Experience the first 7 days of Anima’s AI companion for free when you subscribe today. Get personalized support, neuroscience-based insights, and daily guidance — all in one place. After the trial, it’s just $12.99/month. Cancel anytime';

                        }
                        return el;
                    });
                this.configPayPal(this.items[0]);
            });
    }

    get isLoggedIn() {
        return this.auth.isLoggedIn;
    }

    ngOnDestroy() {
        if (this.$latestResultId) {
            this.$latestResultId.unsubscribe();
        }
        if (this.$getPlan) {
            this.$getPlan.unsubscribe();

        }
        if (this.$userState) {
            this.$userState.unsubscribe();

        }
    }

    getPlan() {
        const plansetEndpoint = 'default';
        return this.planSets.getPlans(this.environment.apiUrl, plansetEndpoint);
    }

    switchPlan(plan: any) {
        this.configPayPal(plan);
    }

    configPayPal(plan) {
        this.activePlan = plan;
        this.payPalConfig = this.composeConfig(plan);
    }

    loadScript() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.id = 'subs';
            script.type = 'text/javascript';
            script.src = `https://www.paypal.com/sdk/js?client-id=${environment.paypalId}&vault=true&components=buttons`;
            script.src += '&intent=subscription';

            script.onload = () => {
                resolve({script: 'paypal', loaded: true, status: 'Loaded'});
            };
            script.onerror = () => reject({script: '', loaded: false, status: 'Loaded'});
            document.getElementsByClassName('pricing-wrapper')[0].appendChild(script);
        });
    }

    composeConfig(plan): any {
        this.payPalLoading = true;

        this.loadScript()
            .then((res) => {
                paypal.Buttons(
                    {
                        style: {
                            shape: 'rect',
                            layout: 'horizontal',
                            tagline: false
                        },
                        createSubscription: (data, actions) => {
                            return actions.subscription.create({
                                plan_id: plan.id,
                                custom_id: this.auth.userData?.uid
                            });
                        },
                        onApprove: (data) => {
                            this.data.orderId = data.orderID;
                            this.$userState = this.auth.$userState.subscribe((user: any) => {
                                if (user.subscription) {
                                    this.gtService.event('payment_success')
                                        .then(() => {
                                            this.busy.setState(false);
                                            if (this.successRoute) {
                                                this.loading = false;
                                                return this.router.navigate([this.successRoute]);
                                            }
                                        })
                                        .catch();
                                }
                            });
                        },
                        onCancel: () => {
                            this.busy.setState(false);
                        },
                        onError: (err) => {
                            this.busy.setState(false);
                            this.paymentError = true;
                            this.tostr.error(err?.error?.error_description || err.error || err.message, err.statusText);
                        },
                        onClick: (data, actions) => {
                            if (data.fundingSource === 'paypal') {
                                this.busy.setState(true);
                            }
                        }
                    }).render('#paypal-button-container');
            })
            .then(() => {
                this.payPalLoading = false;
            });
    }
}
